import React from 'react';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  left: {
    textAlign: 'left',
  },
  popOver: {
    background: '#FFFFFF',
    border: '1px solid #E7E7E7',
    borderRadius: '5px',
    boxShadow: '2px 6px 10px rgba(0, 0, 0, 0.1)',
    boxSizing: 'border-box',
  },
}));

function Item({ value }) {
  return <div style={{ backgroundColor: value, borderRadius: 10, height: 19, width: '100%' }} />;
}

export default ({ value, onChange, items }) => {
  const classes = useStyles();

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    onChange(selectedValue);
  };

  const menuItems = items.map((item) => {
    return (
      <MenuItem key={item.value} value={item.value}>
        <Item value={item.value} />
      </MenuItem>
    );
  });

  return (
    <Select
      labelId="select-label"
      id="select"
      fullWidth
      value={{ value }}
      onChange={handleChange}
      className={classes.left}
      renderValue={Item}
      MenuProps={{
        PopoverClasses: {
          paper: classes.popOver,
        },
      }}>
      {menuItems}
    </Select>
  );
};
